import { ProjectType, type ProjectTypeValue } from '@/constants/projectTypes'

export function projectTypeLabel(type: string | undefined | null): string {
  const t = type || ProjectType.NOVEL
  const labels: Record<ProjectTypeValue, string> = {
    [ProjectType.NOVEL]: 'Novela',
    [ProjectType.SHORT_STORY_ANTHOLOGY]: 'Antología',
    [ProjectType.POETRY_COLLECTION]: 'Poemario',
    [ProjectType.SCREENPLAY]: 'Guion',
  }
  return labels[t as ProjectTypeValue] ?? labels[ProjectType.NOVEL]
}

/** Singular label for a writing unit (chapter / story / poem / scene). */
export function unitSingularLabel(type: string | undefined | null): string {
  const t = type || ProjectType.NOVEL
  const labels: Record<ProjectTypeValue, string> = {
    [ProjectType.NOVEL]: 'Capítulo',
    [ProjectType.SHORT_STORY_ANTHOLOGY]: 'Cuento',
    [ProjectType.POETRY_COLLECTION]: 'Poema',
    [ProjectType.SCREENPLAY]: 'Escena',
  }
  return labels[t as ProjectTypeValue] ?? labels[ProjectType.NOVEL]
}

export function unitPluralLabel(type: string | undefined | null): string {
  const t = type || ProjectType.NOVEL
  const labels: Record<ProjectTypeValue, string> = {
    [ProjectType.NOVEL]: 'Capítulos',
    [ProjectType.SHORT_STORY_ANTHOLOGY]: 'Cuentos',
    [ProjectType.POETRY_COLLECTION]: 'Poemas',
    [ProjectType.SCREENPLAY]: 'Escenas',
  }
  return labels[t as ProjectTypeValue] ?? labels[ProjectType.NOVEL]
}

export function newUnitButtonLabel(type: string | undefined | null): string {
  const u = unitSingularLabel(type)
  return `Nuevo ${u.toLowerCase()}`
}

export function unitTitlePlaceholder(type: string | undefined | null): string {
  const u = unitSingularLabel(type)
  return `Título del ${u.toLowerCase()}...`
}

export function loadingUnitLabel(type: string | undefined | null): string {
  const u = unitSingularLabel(type)
  return `Cargando ${u.toLowerCase()}...`
}

export function nextUnitButtonLabel(type: string | undefined | null): string {
  return `${unitSingularLabel(type)} siguiente`
}

export function createNextUnitButtonLabel(): string {
  return 'Crear siguiente'
}

export function unitNotFoundToastMessage(type: string | undefined | null): string {
  const u = unitSingularLabel(type).toLowerCase()
  if (u === 'escena') return 'La escena buscada no existe'
  return `El ${u} buscado no existe`
}

export function unitDeletedToastMessage(type: string | undefined | null): string {
  const u = unitSingularLabel(type).toLowerCase()
  if (u === 'escena') return 'La escena fue eliminada'
  return `El ${u} fue eliminado`
}
